'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = 'M256 0c36.4 0 68.3 19.3 86.1 48.2 33-7.9 69.2 1.1 94.9 26.8s34.7 62 26.8 94.9C492.7 187.7 512 219.6 512 256s-19.3 68.3-48.2 86.1c7.9 33-1.1 69.2-26.8 94.9s-62 34.7-94.9 26.8C324.3 492.7 292.4 512 256 512s-68.3-19.3-86.1-48.2c-33 7.9-69.2-1.1-94.9-26.8s-34.7-62-26.8-94.9C19.3 324.3 0 292.4 0 256s19.3-68.3 48.2-86.1c-7.9-33 1.1-69.2 26.8-94.9s62-34.7 94.9-26.8C187.7 19.3 219.6 0 256 0zm0 16c-32.6 0-60.9 18.3-75.2 45.2-1.8 3.4-5.7 5-9.4 3.9-29.1-8.9-62.1-1.9-85.2 21.1s-30.1 56-21.1 85.2c1.1 3.7-.5 7.6-3.9 9.4-26.9 14.3-45.2 42.6-45.2 75.2s18.3 60.9 45.2 75.2c3.4 1.8 5 5.7 3.9 9.4-8.9 29.1-1.9 62.1 21.1 85.2s56 30.1 85.2 21.1c3.7-1.1 7.6 .5 9.4 3.9 14.3 26.9 42.6 45.3 75.2 45.3s60.9-18.3 75.2-45.3c1.8-3.4 5.7-5 9.4-3.9 29.1 8.9 62.1 1.9 85.2-21.1s30.1-56 21.1-85.2c-1.1-3.7 .5-7.6 3.9-9.4 26.9-14.3 45.3-42.6 45.3-75.2s-18.3-60.9-45.3-75.2c-3.4-1.8-5-5.7-3.9-9.4 8.9-29.1 1.9-62.1-21.1-85.2s-56-30.1-85.2-21.1c-3.7 1.1-7.6-.5-9.4-3.9-14.3-26.9-42.6-45.2-75.2-45.2zm81.7 147.7c2.6-3.6 7.6-4.3 11.2-1.7s4.3 7.6 1.8 11.2L236.9 329.5c-1.4 1.9-3.6 3.1-5.9 3.3s-4.7-.7-6.3-2.4l-62.3-64.5c-3.1-3.2-3-8.2 .2-11.3s8.2-3 11.3 .2l55.7 57.6 108.1-148.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;